/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { FC } from 'react';
import { Stack, Button } from '@mui/material';
import { ModalActions } from '../../../../components/Modal';
import { Loader } from '../../../../components/Loader';

export interface ActivityModalActionBarProps {
  showLoadingIndicator: boolean;
  loadingIndicatorText: string;
  loadingIndicatorTestId?: string;
  closeButtonText: string;
  closeButtonTestId?: string;
  submitButtonText: string;
  submitButtonTestId?: string;
  disableSubmit?: boolean;
  onClose: VoidFunction;
  onSubmit: VoidFunction;
  showDivider?: boolean;
}

const ActivityModalActionBar: FC<ActivityModalActionBarProps> = ({
  showLoadingIndicator,
  loadingIndicatorText,
  loadingIndicatorTestId,
  closeButtonText,
  closeButtonTestId,
  submitButtonText,
  submitButtonTestId,
  disableSubmit,
  onClose,
  onSubmit,
  showDivider = true,
}): JSX.Element => {
  return (
    <ModalActions showDivider={showDivider}>
      {showLoadingIndicator ? (
        <Loader
          data-testid={loadingIndicatorTestId}
          title={loadingIndicatorText}
          type='inline-flex'
        />
      ) : (
        <Stack direction='row' gap={2} justifyContent='flex-end' width='100%'>
          <Button onClick={onClose} data-testid={closeButtonTestId} sx={{ textDecoration: 'none' }}>
            {closeButtonText}
          </Button>
          <Button
            disabled={disableSubmit}
            variant='contained'
            data-testid={submitButtonTestId}
            onClick={onSubmit}
          >
            {submitButtonText}
          </Button>
        </Stack>
      )}
    </ModalActions>
  );
};

export default ActivityModalActionBar;
